import React, { useContext, useState, useEffect, useRef } from "react";
import { ThemeContext } from "../../context/ThemeContext";
import { FaMoon, FaSun, FaBell, FaBars } from "react-icons/fa";
import { useLocation, useNavigate } from "react-router-dom";

const Topbar = ({ alerts, toggleSidebar }) => {
  const navigate = useNavigate();
  const { darkMode, toggleTheme } = useContext(ThemeContext);
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const unreadCount = alerts.length;

  // ✅ Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="w-full h-16 bg-gray-800 dark:bg-gray-900 flex justify-between items-center px-6 relative">
      {/* Left Section: Hamburger & Logo */}
      <div className="flex items-center gap-4">
        {/* Hamburger Icon for Mobile */}
        <button className="lg:hidden p-2 bg-gray-700 rounded" onClick={toggleSidebar}>
          <FaBars className="text-white text-xl" />
        </button>
      </div>

      <h2 className="text-lg font-semibold text-white">Welcome, Admin</h2>
      <div className="flex items-center gap-6">
        {/* Notifications */}
        <div className="relative" ref={dropdownRef}>
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="relative p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition"
          >
            <FaBell className="text-white text-xl" />
            {unreadCount > 0 && (
              <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs font-bold rounded-full px-1.5">
                {unreadCount}
              </span>
            )}
          </button>

          {/* Dropdown */}
          {isOpen && (
            <div className="absolute right-0 mt-2 w-80 bg-gray-800 border border-gray-700 rounded-lg shadow-lg z-50">
              <div className="p-3 font-bold text-white border-b border-gray-700">Notifications</div>
              <div className="max-h-64 overflow-y-auto">
                {alerts.length === 0 ? (
                  <p className="p-3 text-gray-400">No alerts yet</p>
                ) : (
                  alerts.slice(-5).reverse().map((alert) => (
                    <div key={alert.id} className="p-3 border-b border-gray-700 hover:bg-gray-700">
                      <p className="font-semibold text-sm">{alert.type}</p>
                      <p className="text-xs text-gray-300">{alert.message}</p>
                      <p className="text-xs text-gray-500 mt-1">{alert.time}</p>
                    </div>
                  ))
                )}
              </div>
              <div
                onClick={() => navigate("/alerts")}
                className="p-3 text-center text-blue-400 cursor-pointer hover:underline"
              >
                View All
              </div>
            </div>
          )}
        </div>

        {/* Theme Toggle */}
        <button
          onClick={toggleTheme}
          className="p-2 rounded-full bg-gray-700 hover:bg-gray-600 transition"
        >
          {darkMode ? <FaSun className="text-yellow-400" /> : <FaMoon />}
        </button>
      </div>
    </div>
  );
};

export default Topbar;
